<template>
    <form @submit.prevent="onSubmit" class="h-full mx-auto flex justify-center items-center px-8">
    <div class="w-full bg-white shadow-lg" style="max-width:400px">
      <div class="bg-red-500 p-4 px-8 shadow text-white text-2xl font-semibold">Praksispoolen</div>
      <div class="p-12">

        <!-- <div class="text-center text-3xl font-bold">
          Innlogging
        </div> -->

        <div>
          <label class="font-bold block" for="username">Brukernavn</label>
          <input class="w-full mt-1" type="text" name="username" id="username" autocomplete v-model="username" ref="username" required placeholder="E-post adresse">
        </div>

        <div class="mt-4">
          <label class="font-bold block" for="password">Passord</label>
          <input class="w-full mt-1" type="password" name="password" id="password" autocomplete v-model="password" required>
        </div>

        <div class="p-4 mt-6 bg-red-100 border-2 border-red-300 rounded-lg text-center shadow-lg w-64 mx-auto" v-show="error">
          {{ error }}
        </div>

        <div class="flex flex-col md:flex-row items-center justify-center mt-12">
          <button type="submit" class="btn btn-primary">Logg inn</button>
          <router-link class="mt-2 md:mt-0 ml-0 md:ml-4 text-sm text-gray-700 inline-block hover:underline" :to="{ name: 'reset-password' }">Opprett/endre passord?</router-link>
        </div>

      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      error: null,
      username: '',
      password: ''
    }
  },
  methods: {
    redirectHome () {
      this.$store.dispatch('me').then(() => {

        let role = this.$store.getters['user'].role

        const url = role === 'admin' ? '/af/forside' :
                    role === 'pharmacy' ? '/ap/forside' :
                    role === 'university' ? '/pk/forside' :
                    role === 'chain' ? '/kk/forside' : ''

        if (url) {
          this.$router.push(url)
        } else {
          this.error = 'Ukjent bruker.'
        }
      })
    },
    onSubmit () {
      this.$store.dispatch('login', {
        username: this.username,
        password: this.password
      }).then(() => {
        this.redirectHome()
      }).catch(error => {
        this.error = error
      })
    }
  }
}
</script>

